import { render, staticRenderFns } from "./messageSendDetail.vue?vue&type=template&id=ebb567a8&"
import script from "./messageSendDetail.vue?vue&type=script&lang=js&"
export * from "./messageSendDetail.vue?vue&type=script&lang=js&"
import style0 from "./messageSendDetail.vue?vue&type=style&index=0&id=ebb567a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports